module.exports = __webpack_public_path__ + "img/Bolt_logo.25ac1400.png";